/** Fallback when GET /sec-filings/meta has not loaded (matches backend SEC_PERIODS). */
export const FALLBACK_SEC_PERIODS = [
  { key: '1D', label: 'Last 1 day' },
  { key: '1W', label: 'Last 1 week' },
  { key: '1M', label: 'Last 1 month' },
  { key: '1Q', label: 'Last 1 quarter' },
  { key: '1Y', label: 'Last 1 year' },
];

export const resolveSecPeriods = (meta) => (
  meta?.periods?.length ? meta.periods : FALLBACK_SEC_PERIODS
);
